import global from "../global.js";

const log = global.log.getLogger("f_mtac.scene.renderer_static_map");
log.setLevel(log.levels.WARN);

const RendererStaticMap = function(gis_state, map) {
    log.debug(" RendererStaticMap ",gis_state);

    const static_map_blob_create = async () => {
        return global.view.ol_driver.static_map_create_blob_tiles(gis_state);
    };

    const canvas_init = (width, height) => {
        var canvas = document.createElement("canvas");
        var context = canvas.getContext("2d");
        canvas.width = width;
        canvas.height = height;
        context.clearRect(0, 0, width, height);
        return {canvas, context};
    };

    const canvas_crop = (old_canvas, width, height) => {
        var {canvas, context} = canvas_init(width, height);
        context.drawImage(old_canvas, 0, 0, width, height, 0, 0, width, height);
        return {canvas, context};
    };

    this.mime_type = "image/jpeg";
    this.quality = 0.9;

    const canvas_trace = (canvas) => {
        return new Promise((resolve) => {
            canvas.toBlob(blob => resolve(blob), this.mime_type, this.quality);
        });
    };

    const context_render_blob = async (context, blob, x1, y1, x2, y2, k, width, height) => {
        log.debug("context_render_blob ",{x1, y1, k, width, height});
        const image = new Image();
        image.width = k * width;
        image.height = k * height;
        return new Promise((resolve) => {
            const blob_url = window.URL.createObjectURL(blob);
            log.debug("blob_url ",blob_url);
            image.onload = function() {
                context.drawImage(image, x2, y2/*, k * width, k * height, x1, y1, width, height*/);
                resolve();
                window.URL.revokeObjectURL(blob_url);
            };
            image.src = blob_url;
        });
    };

    this.createStaticMap = async () => {
        if (!map.loaded) { // nothing to export
            return;
        }
        const {width, height} = map;
        const {x, y, k} = map.transform.state;

        let tiles_blob = [];
        tiles_blob = await static_map_blob_create(/*x + k * width, y + k * height*/);
        log.debug("tiles_blob ",tiles_blob);

        // we need to initialize the canvas size to the maximum possible value between
        // the raster image and the grid to contain both of them
        let {canvas, context} = canvas_init(Math.max(1, k) * width + x, Math.max(1, k) * height + y);
        for (var index in tiles_blob) {
            await context_render_blob(context, tiles_blob[index].blob, tiles_blob[index].coordinates.x, tiles_blob[index].coordinates.y, tiles_blob[index].coordinates.x, tiles_blob[index].coordinates.y, k, width, height);    
        }
        ({canvas, context} = canvas_crop(canvas, width, height));

        return await canvas_trace(canvas);
    };
};

export default RendererStaticMap;
